export type BatteryIndicatorToLabelConversion = (indicatorValue: number) => string;

export const sproutBatteryLabelConversion: BatteryIndicatorToLabelConversion = (voltage) => {
    if (voltage === undefined || voltage < 1 || voltage > 11) {
        return "N/A";
    }
    return (voltage || 0).toString() + "V";
};

/** @deprecated Never called — sap_* device types are RETIRED and batteryIndicatorToSpecificLabel has no call sites. */
export const saplingBatteryLabelConversion: BatteryIndicatorToLabelConversion = (percentage) => {
    if (percentage === undefined || percentage < 0) {
        return "N/A";
    }
    return Math.round((percentage || 0) * 100).toString() + "%";
};
